<!-- 权限管理-后付费-产看账单 -->
<template>
  <div>
    <div class="model-box">
      <div class="model-title">
        <span>历史账单</span>
      </div>
      <div class="model-content">
        <div v-if="djsInfoList.length>0">
          <div class="bill-list-model" v-for="(item,index) in djsInfoList" :key="index">
            <div class="bill-info clearfix">
              <p>账单期间：{{item.startTime}}-{{item.endTime}}</p>
              <p>账单金额：¥{{item.billAmount}}</p>
              <p>结算日期：{{item.realSettleTime}}</p>
            </div>
            <el-tabs v-model="item.itemActiveName" @tab-click="handleClick" v-if="item.accountDetailResList.length>0">
              <el-tab-pane v-for="(itemChild,indexChild) in item.accountDetailResList" :key="indexChild" :label="itemChild.interName" :name="itemChild.interId">
                <el-table
                  v-if="item.itemActiveName==itemChild.interId"
                  :data="itemChild.children"
                  border
                  header-row-class-name="tableHead"
                  style="width: 65.2%">
                  <el-table-column
                    prop="interName"
                    label="接口名称"
                    min-width="30%">
                  </el-table-column>
                  <el-table-column
                    prop="interUnitPrice"
                    label="接口单价（元）"
                    min-width="20%">
                  </el-table-column>
                  <el-table-column
                    label="计费方式"
                    min-width="20%">
                    <template slot-scope="scope">
                      <span v-if="scope.row.feeType==1">查得</span>
                      <span v-if="scope.row.feeType==2">查询</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="interUseNum"
                    label="调用次数"
                    min-width="20%">
                  </el-table-column>
                  <el-table-column
                    prop="interSubtotal"
                    label="小计（元）"
                    min-width="20%">
                  </el-table-column>
                  <el-table-column
                    label="明细"
                    min-width="10%">
                    <template slot-scope="scope">
                      <a @click="jkdyDetailsFun(scope.row,itemChild.interName,item.startTime,item.endTime)">查看</a>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div v-if="djsInfoList.length==0">
          <p class="noData">暂无数据</p>
        </div>
      </div>
    </div>
    <el-dialog
      title="接口调用详情"
      :visible.sync="jkdyDialogVisible"
      width="1000px"
      :close-on-click-modal='false'>
      <div class="dialog-content">
        <p class="title2">接口信息</p>
        <table class="public-table">
          <tr>
            <td class="td-head">接口类型</td>
            <td>{{jkdyDetailInfo.jklx}}</td>
            <td class="td-head">接口名称</td>
            <td>{{jkdyDetailInfo.jkInfo.interName}}</td>
          </tr>
        </table>
        <p class="title2">调用信息</p>
        <p class="tishi">共 {{jkdySend.totalCount}} 次调用</p>
        <el-table
          :data="jkdyDetailInfo.dyInfo"
          border
          header-row-class-name="tableHead"
          style="width: 100%">
          <el-table-column
            label="序号"
            align="center"
            width="50">
            <template slot-scope="scope">
              {{(jkdySend.page-1)*jkdySend.pageSize+scope.$index+1}}
            </template>
          </el-table-column>
          <el-table-column
            prop="operationTime"
            label="请求时间"
            min-width="20%">
          </el-table-column>
          <el-table-column
            prop="requestParams"
            label="请求参数"
            min-width="25%">
          </el-table-column>
          <el-table-column
            prop="requestIp"
            label="请求IP"
            min-width="15%">
          </el-table-column>
          <el-table-column
            prop="responseCode"
            label="响应吗"
            min-width="10%">
          </el-table-column>
          <el-table-column
            label="请求结果"
            min-width="30%">
            <template slot-scope="scope">
              <json-viewer
                class="pre-box resultInstance"
                :value="scope.row.responseData"
                :expand-depth=0
                boxed
                sort>
              </json-viewer>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="jkdySend.totalCount>10"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page="jkdySend.page"
          :page-size="jkdySend.pageSize"
          :total="jkdySend.totalCount">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AfterpayBillPage',
  data () {
    return {
      userId:this.$route.query.id || '',
      apiInfo:{},
      dictionary:JSON.parse(localStorage.getItem('dictionary')),
      activePage: 'djszd',
      djsInfoList:[],
      jkdyDialogVisible:false,
      jkdySend:{
        page:1,
        pageSize:10,
        totalCount:0
      },
      jkdyDetailInfo:{
        jkInfo:{},
        dyInfo:[]
      },
    }
  },
  mounted () {
    var _this=this;
    _this.getInfoDataFun();
  },
  updated(){
  },
  methods:{
    handleClick(tab, event) {
      var _this=this;
      _this.$nextTick(() => {

      });
    },
    // 查看用户信息
    getInfoDataFun:function(){
      var _this=this;
      var sendData=new Object();
      sendData.billType=1;
      sendData.userId=_this.userId;
      _this.$axios.post("/requestApi/after/pay/bill/show",sendData)     
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){   
            _this.djsInfoList=[];
            _this.djsInfoList=data.data;
            _this.djsInfoList.forEach(function(item){
              item.accountDetailResList.forEach(function(itemSecond){
                itemSecond.children.forEach(function(itemThird){
                  if(itemThird.interUnitPrice==null){
                    itemThird.interUnitPrice=0;
                  };
                });
              });
              item.itemActiveName=item.accountDetailResList[0].interId;
            });
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    // 分页
    handleCurrentChange:function(val) {
      var _this=this;
      _this.jkdySend.page = val;
      _this.jkdyArrDetailsFun();
    },
    //接口调用详情
    jkdyDetailsFun:function(obj,name,startTime,endTime){
      var _this=this;
      console.log(name)
      _this.jkdyDetailInfo.jklx=name;
      _this.jkdyDetailInfo.url='/requestApi/fee/find/normal/request';
      _this.jkdyDetailInfo.jkInfo=obj;
      _this.jkdySend.page=1;
      _this.jkdyArrDetailsFun(startTime,endTime);
    },
    //接口详情数据调用
    jkdyArrDetailsFun:function(startTime,endTime){
      var _this=this;
      var sendData=new Object();
      sendData.page=_this.jkdySend.page;
      sendData.pageSize=_this.jkdySend.pageSize;
      sendData.userId=_this.userId;
      sendData.interId=_this.jkdyDetailInfo.jkInfo.interId;
      sendData.startDate=startTime;
      sendData.endDate=endTime;
      _this.$axios.post(_this.jkdyDetailInfo.url,sendData)      
      .then(function(response){
        let data = response.data;
        if(data.meta.retCode==0){
          _this.jkdySend.totalCount=data.data.totalCount;
          _this.jkdyDetailInfo.dyInfo=data.data.resultList;
          _this.jkdyDetailInfo.dyInfo.forEach(function(item){
            item.responseData=JSON.parse(item.responseData);
          });
          _this.jkdyDialogVisible=true;
        }else{
          console.log(data.meta.friendlyMsg);
        }
      })
      .catch(function(error){
        console.log(error)
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.jbxx-table tr td{width: 35%;}
.jbxx-table tr .td-head{width: 15%;}
.select-box-btn{margin: 0 auto;}
.public-table tr td{width: 23.3333%;}
.public-table tr .td-head{width: 10%;}
.title{font-size: 22px;margin-bottom: 20px;text-align: center; color: #333;}
.title2{font-size: 16px;display: block;border-left: 2px solid #333;text-indent: 6px;margin-bottom: 10px;margin-top: 20px;}
.dy-select-box{margin-bottom: 20px;}
.tishi{margin-bottom: 10px;}
.el-dialog .dialog-content>.title2:nth-child(1){margin-top: 0px;}
.bill-list-model{border-bottom: 1px solid #f3f3f3;padding-top: 20px;padding-bottom: 20px;}
.bill-list-model:first-child{padding-top: 5px;}
.bill-list-model:last-child{padding-bottom: 0px;border-bottom:none;}
.bill-info{width: 100%;height: 40px; margin-bottom: 10px;}
.bill-info p,.bill-info a{display: inline-block; margin-right: 80px;line-height: 40px;}
.bill-btn{display: inline-block;float: right;}
</style>



// WEBPACK FOOTER //
// src/components/HistoricalBill.vue